import React from "react";
import styles from "./FeaturedStory.module.scss";
import Link from "gatsby-link";
import featuredImage from "../../images/research/transepi_featured.jpg";
import Arrow from "../icons/Arrow";
import Img from "gatsby-image";

const FeaturedStory = ({ style, story }) => {
	return (
		<div className={styles.outer_wrapper} style={style}>
			<div className="container">
				<div className={"row " + styles.row}>
					<div
						className={"col-12 col-lg-11 " + styles.featured_image}
					>
						<Link
							to={
								"/" +
								story.node_locale +
								"/research/story/" +
								story.slug
							}
						>
							<Img
								title={story.title}
								alt={story.title}
								sizes={story.featuredImage.sizes}
							/>
						</Link>
					</div>
					<div className={"col-12 col-lg-5 col-xl-4 " + styles.featured_post}>
						<span className={styles.featured_post_category}>
							Research Spotlight
						</span>
						<b>
							<h3>
								<Link
									to={
										"/" +
										story.node_locale +
										"/research/story/" +
										story.slug
									}
								>
									{story.title}
								</Link>
							</h3>
						</b>
						<p className="text-dark">
							{story.content.childMarkdownRemark.excerpt}
						</p>
						<Link
							className={styles.read_more}
							to={
								"/" +
								story.node_locale +
								"/research/story/" +
								story.slug
							}
						>
							Read more
							<Arrow />
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FeaturedStory;



// WEBPACK FOOTER //
// ./src/components/FeaturedStory/index.js